module.exports = __webpack_public_path__ + "img/logoFront.5bd52d07.png";